function initRowndVip() {
  const dialog = document.querySelector('#join-dialog');
  const form = document.querySelector('#join-form');
  const formView = document.querySelector('#form-view');
  const summaryView = document.querySelector('#summary-view');
  const note = document.querySelector('#preview-note');
  const offer = document.querySelector('.sticky-offer');
  if (!dialog) return;

  let opener;
  function resetView() {
    if (formView) formView.hidden = false;
    if (summaryView) summaryView.hidden = true;
    dialog.setAttribute('aria-labelledby', 'dialog-title');
    if (note) note.textContent = 'Preview only. No payment or registration will be processed. Please use sample details.';
  }

  const VIP_VARIANT_ID = 46231520509996;

  function join(event) {
    if (event) {
      event.preventDefault();
      const target = event.currentTarget;
      if (target) {
        target.style.opacity = '0.7';
        target.style.pointerEvents = 'none';
      }
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: VIP_VARIANT_ID,
        quantity: 1
      })
    })
    .then(function() {
      window.location.href = '/checkout';
    })
    .catch(function(err) {
      window.location.href = '/cart/' + VIP_VARIANT_ID + ':1';
    });
  }

  document.querySelectorAll('[data-join]').forEach(button => {
    button.removeEventListener('click', join);
    button.addEventListener('click', join);
  });

  document.querySelectorAll('[data-close]').forEach(button => {
    button.addEventListener('click', () => dialog.close());
  });

  dialog.addEventListener('close', () => {
    document.body.classList.remove('modal-open');
    if (form) form.reset();
    if (opener) opener.focus({ preventScroll: true });
  });

  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const box = dialog.getBoundingClientRect();
    if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
  });

  if (form) {
    form.addEventListener('submit', event => {
      event.preventDefault();
      window.location.href = DEFAULT_CHECKOUT_URL;
    });
  }

  const backBtn = document.querySelector('#back-to-form');
  if (backBtn) {
    backBtn.addEventListener('click', () => {
      resetView();
      const firstInput = form ? form.querySelector('input') : null;
      if (firstInput) firstInput.focus({ preventScroll: true });
    });
  }

  document.querySelectorAll('.mobile-links a').forEach(link => {
    link.addEventListener('click', () => {
      const mob = document.querySelector('.mobile-nav');
      if (mob) mob.open = false;
    });
  });

  document.addEventListener('click', event => {
    const menu = document.querySelector('.mobile-nav');
    if (menu && !menu.contains(event.target)) menu.open = false;
  });

  if ('IntersectionObserver' in window && offer) {
    let heroVisible = true;
    let finalVisible = false;
    const heroEl = document.querySelector('.hero');
    const finalEl = document.querySelector('.final-section');
    const updateOffer = () => offer.classList.toggle('visible', !heroVisible && !finalVisible);
    if (heroEl) {
      new IntersectionObserver(entries => { heroVisible = entries[0].isIntersecting; updateOffer(); }, { threshold: 0 }).observe(heroEl);
    }
    if (finalEl) {
      new IntersectionObserver(entries => { finalVisible = entries[0].isIntersecting; updateOffer(); }, { threshold: 0 }).observe(finalEl);
    }
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initRowndVip);
} else {
  initRowndVip();
}
document.addEventListener('shopify:section:load', initRowndVip);
